import { MenuItem } from "@mui/material"
import { LocalizedEnum, LocalizedStrict } from "../../../../../localization/components/AppLocalized"
import { FormikDropdown } from "../../../../../../shared/components/forms/Formik"
import { ImportBillReceiversFormValues, ReceiverType } from "../importBillReceiversTypes"

export function SelectReceiverTypeDropdown() {
    return (
        <LocalizedStrict id="company-data-import-bill-receivers-receiver-type" attrs={{ label: true }}>
            <FormikDropdown<ImportBillReceiversFormValues> name="receiverType" label="Receiver type">
                {Object.values(ReceiverType).map((item) => {
                    return (
                        <MenuItem key={item} value={item}>
                            <LocalizedEnum
                                base="company-data-import-bill-receivers-receiver-type-mode"
                                enumValue={item}
                            >
                                <> {item}</>
                            </LocalizedEnum>
                        </MenuItem>
                    )
                })}
            </FormikDropdown>
        </LocalizedStrict>
    )
}
